<h3 mat-dialog-title style="text-align: center;">ESTATE MAPS</h3>
<div mat-dialog-content>
    <mat-spinner *ngIf="!this.data.showClose" diameter=50 class="aip-topol-spinner" [ngStyle]="{'margin-left': this.data.marginLeft}"></mat-spinner>
    <div *ngIf="this.data.showClose">
       <p style="text-align: center;">Thank you!</p>
       <p style="text-align: center;">{{ this.data.message }}</p>
    </div>
</div>
<mat-dialog-actions align="end" *ngIf="this.data.showClose">
   <button mat-raised-button class="aip-button-alt" (click)="close()">Close</button>
</mat-dialog-actions>